// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"579f871e","752":"5e97f102"}[chunkId] + ".chunk.js";
};